import type { InatoHealthCheckService } from '../application/InatoHealthCheckService';

export class InatoHealthCheckServiceImpl implements InatoHealthCheckService {
  constructor(private readonly apiUrl: string) {}

  private get healthApiUrl() {
    return `${this.apiUrl}/health`;
  }

  ok = async () =>
    fetch(this.healthApiUrl)
      .then(({ ok }) => ok)
      .catch(() => false);
}
